import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import Completion from "src/core/assets/images/icons/completion.svg?react";
import Calculer from "src/core/assets/images/icons/lg-calculer.svg?react";
import Moduler from "src/core/assets/images/icons/lg-moduler.svg?react";
import { Status } from "src/core/constants/folders";
import { CustomRiskLevel } from "src/core/constants/risk";
import { FolderFile } from "src/core/gql/graphql";
import { cn } from "src/core/lib/utils";
import { mapRiskLevelToCustomRiskLevel } from "src/core/mappers/risk.mapper";
import { dateFolderFinished } from "src/core/utils/folder";
import { getRiskClass } from "src/core/utils/riskClass";

export const FolderCardRiskEC: React.FC<{ folderFile: FolderFile }> = ({ folderFile }) => {
  const { t } = useTranslation();
  const risk =
    folderFile.workflowStatus?.state?.code === Status.DRAFT
      ? CustomRiskLevel.IN_PROGRESS
      : mapRiskLevelToCustomRiskLevel(folderFile?.riskStatus?.globalRiskLevel) ??
        CustomRiskLevel.UNDEFINED;

  const finishedDate = dateFolderFinished(folderFile);

  return (
    <div className="folder-card-risk">
      {folderFile.workflowStatus?.state?.code === Status.DRAFT ? (
        <Completion className="w-30 h-30" />
      ) : folderFile?.riskStatus?.forcedRisk === null ? (
        <Calculer className="w-30 h-30" />
      ) : (
        <Moduler className="w-30 h-30" />
      )}
      <div className="flex flex-col gap-y-5 w-full justify-center items-center">
        <div
          className={cn(
            "rounded-lg text-gray-xlight text-xs font-light px-15 py-5 w-fit",
            getRiskClass("dot", risk)
          )}
        >
          {t(`form.modulerRisk.${risk.toLowerCase()}Risk`)}
        </div>

        <div className="text-xs font-light flex flex-row gap-x-5">
          {finishedDate
            ? t("folder.versions.finishedDate", {
                date: format(finishedDate, "dd/MM/yyyy"),
              })
            : t(
                `folder.versions.${
                  folderFile.workflowStatus?.state?.code === Status.DRAFT
                    ? "inProgress"
                    : folderFile.workflowStatus?.state?.code === Status.VALIDATION_PENDING ||
                      folderFile.workflowStatus?.state?.code === Status.VALIDATION_PENDING_HR
                    ? "validationPending"
                    : folderFile.workflowStatus?.state?.code === Status.REJECTED
                    ? "refused"
                    : "validation"
                }`,
                {
                  date: format(folderFile.workflowStatus?.lastModification, "dd/MM/yyyy"),
                }
              )}
        </div>
      </div>
    </div>
  );
};
